import { Button } from '@commenda/kakashi';

export const SecureInformationRequestLayoutFooter = ({
  onSaveAndExitProps,
  submitProps,
  onCancel,
}: {
  onSaveAndExitProps?: {
    isEnabled: boolean;
    onClick: () => void;
  };
  submitProps: {
    isEnabled: boolean;
    onClick: () => void;
  };
  onCancel: () => void;
}) => {
  return (
    <div className="border-t p-xl flex justify-between items-center">
      {onSaveAndExitProps?.onClick ? (
        <Button
          variant="secondary"
          size="sm"
          onClick={onSaveAndExitProps.onClick}
          disabled={!onSaveAndExitProps.isEnabled}
        >
          Save and exit
        </Button>
      ) : (
        <span />
      )}
      <div className="flex items-center gap-lg">
        <Button variant="secondary" size="sm" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={submitProps.onClick}
          disabled={!submitProps.isEnabled}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
